<div class="chat-container" [ngClass]="{'empty': messages.length === 0}">
    <ul #messagesList class="chat-messages">
        <li *ngFor="let message of messages" [ngClass]="{'my-message': message.isMine}">
            <span class="chat-author">{{message.author}}</span>
            <p class="chat-text">{{message.text}}</p>
            <span class="chat-datetime" [ngClass]="{'my-message-datetime': message.isMine}">
                {{ formatDate(message.dateTime) }}
            </span>
        </li>
    </ul>
    <div class="chat-input-container">
        <input type="text" [(ngModel)]="newMessage" (keyup.enter)="sendMessage()" placeholder="Digite sua mensagem...">
        <button class="btn btn-primary" (click)="sendMessage()">Enviar</button>
    </div>
</div>